/* ============================================================================
   MISS JHUMKI — PROGRESSIVE ENHANCEMENTS
   ----------------------------------------------------------------------------
   Deliberately tiny and dependency-free. Everything here is an enhancement:
   with JavaScript disabled the storefront still works, because the product rail
   is a native scroll container and the arrows are the only thing that stops
   responding.

   Re-initialises on shopify:section:load so the theme editor behaves.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Product rail arrows.
   *
   * Scrolls the viewport by exactly one card, measured from the rendered DOM so
   * it stays correct at every breakpoint and after a resize. Arrows are marked
   * `disabled` rather than hidden, so the heading row does not reflow.
   */
  function initRail(root) {
    var viewport = root.querySelector('.mj-rail__viewport');
    var track = root.querySelector('.mj-rail__track');
    var prev = root.querySelector('[data-mj-rail-prev]');
    var next = root.querySelector('[data-mj-rail-next]');

    if (!viewport || !track || !prev || !next || root.dataset.mjRailReady === 'true') return;
    root.dataset.mjRailReady = 'true';

    function step() {
      var item = track.querySelector('.mj-rail__item');
      if (!item) return viewport.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var first = track.querySelector('.mj-rail__item');
      var last = track.querySelector('.mj-rail__item:last-child');
      var viewRect = viewport.getBoundingClientRect();
      var scrollable = viewport.scrollWidth - viewport.clientWidth > 1;

      // Position-based rather than numeric: padding and scroll-snap can leave the
      // container resting at a non-zero scrollLeft, which makes a scrollLeft === 0
      // test report "not at the start".
      var atStart = !first || first.getBoundingClientRect().left >= viewRect.left - 2;
      var atEnd = !last || last.getBoundingClientRect().right <= viewRect.right + 2;

      prev.disabled = !scrollable || atStart;
      next.disabled = !scrollable || atEnd;
    }

    function scrollBy(direction) {
      viewport.scrollBy({
        left: direction * step(),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    prev.addEventListener('click', function () {
      scrollBy(-1);
    });
    next.addEventListener('click', function () {
      scrollBy(1);
    });
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.mj-rail').forEach(initRail);
  }

  /**
   * Size the hero so it ends exactly at the fold.
   *
   * Measures the hero's own distance from the top of the document rather than
   * the header and announcement bar alone. That way any spacing above the hero
   * -- section padding, a taller logo, an extra announcement line -- is already
   * accounted for, and the call to action cannot fall below the fold when one of
   * those changes. The stylesheet carries a fallback, so this is an enhancement.
   */
  function setHeroFold() {
    var hero = document.querySelector('.mj-hero');
    if (!hero) return;
    var top = hero.getBoundingClientRect().top + window.pageYOffset;
    var available = Math.round(window.innerHeight - top);
    if (available > 0) {
      document.documentElement.style.setProperty('--mj-hero-fold', available + 'px');
    }
  }

  // The rail arrows update themselves on resize; only the offset needs refreshing.
  window.addEventListener('resize', setHeroFold);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setHeroFold();
      initAll();
    });
  } else {
    setHeroFold();
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setHeroFold();
    initAll(event.target);
  });
})();
